/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

export const CheckedCircleOutline = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M17.27 8.46012C17.5682 8.74764 17.5775 9.22243 17.29 9.5206L11.5 15.5206C11.2158 15.8153 10.7493 15.8277 10.45 15.5483L7.24 12.5483C6.93719 12.2657 6.91737 11.7911 7.2 11.4883C7.48263 11.1854 7.95719 11.1691 8.26 11.4517L10.94 13.9482L16.21 8.4794C16.4975 8.18123 16.9718 8.1726 17.27 8.46012Z'
		/>
	</svg>
);
